<template>
  <div :class="classes">
      <pt-page-title title="弹屏设置">
      </pt-page-title>
        <div v-for="(item,index) in form.banners" :key="index">
            <pt-sub-title  :title="getTitleForLocation(item.position)" >
                <el-switch slot="line" v-model="item.switch"></el-switch>
            </pt-sub-title>
            <div  :class="$style['active-description']">
            <div>弹屏说明：{{getPositionDescription(item.position)}}</div>
            <div>图片规则({{item.solo?'单个图片':"轮播图片"}})：{{item.width+'px × '+item.height+'px'}}</div>
            </div>
            <table :class="$style['active-table-item']">
              <pt-form-list-item label="链接:" :required="true">
                  <template>
                      <div class="active-url">
                          <wt-input class="url-input" v-model="item.url" data-vv-as="链接：" name="indexUrl"  v-validate="'required'"></wt-input>
                          <el-button type="primary" @click="selctPromotion(item.position,item)">选择</el-button>
                      </div>
                      <div  :class="$style['notes-text']"  v-if="item.switch && !item.url" >您选择的活动没有对应的链接，请自定义链接</div>
                  </template>
              </pt-form-list-item>
              <pt-form-list-item label="描述：">
                  <wt-input v-model="item.description"></wt-input>
              </pt-form-list-item>
              <pt-form-list-item label="活动图片：" :required="true">
                  <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
                  v-model="item.banner"  data-vv-as="首页活动图片" name="indexBanner" v-validate="'required'" :multiple="false" >
                      <div class="main-color">+添加图片</div>
                  </wt-upload-file>
              </pt-form-list-item>
            </table>
        </div>
        <div class="button-div">
            <el-button type="primary" @click="saveActive" :loading="saveLoading">保存</el-button>
        </div>
        <el-dialog :visible="is_select_active" :title="dialog_title" class="message-dialog" @close="closeDialog">
            <message-set v-if="is_select_active" @selectSubmit="selectPromotion"  @close="closeDialog" bannerType="POPUP" :currentItem="currentItem"></message-set>
        </el-dialog>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import messageSet from '../pt-banner-manage/pt-banner-detail/message-set'
import { isEmptyObject } from '@/utils/formUtils'
// 组件class前缀
const prefixCls = 'pt-active-setting'
const HOME = 'HOME'
const MALL = 'MALL'

export default {
  name: 'pt-active-setting',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    activeHome () {
      let data = {}
      this.bannerList.forEach(item => {
        if (item.position === HOME) {
          data = item
        }
      })
      return data
    },
    activeMall () {
      let data = {}
      this.bannerList.forEach(item => {
        if (item.position === MALL) {
          data = item
        }
      })
      return data
    }
  },
  components: {
    messageSet
  },
  props: {
    bannerList: {
      type: Array,
      default: function () {
        return []
      }
    },
    saveLoading: {
      type: Boolean,
      default: false
    },
    positionDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'banner',
        objectId: 0
      },
      privateResourcesUrl: this.$publicResourcesUrl,
      is_select_active: false,
      dialog_title: '',
      form: {
        type: 'POPUP',
        banners: [
        ]
      },
      thePromotionIsUrl: false,
      location: '',
      haveHome: null,
      haveMall: null,
      currentItem: {}
    }
  },
  watch: {
    bannerList: {
      handler: function (val) {
        val.forEach(item => {
          if (item.promotionBannerDTO.position === HOME && !this.haveHome) {
            this.form.banners.unshift({ ...item.promotionBannerDTO, ...item.generalEnumerationDTO.extensionInfo })
            this.haveHome = true
          }
          if (item.promotionBannerDTO.position === MALL && !this.haveMall) {
            this.form.banners.unshift({ ...item.promotionBannerDTO, ...item.generalEnumerationDTO.extensionInfo })
            this.haveMall = true
          }
        })
        if (!this.haveHome) {
          this.form.banners.push({
            position: HOME
          })
        }
        if (!this.haveMall) {
          this.form.banners.push({
            position: MALL
          })
        }
      },
      deep: true
    }
  },
  methods: {
    closeDialog () {
      this.is_select_active = false
    },
    saveActive () {
      this.validate('form').then(res => {
        res.positionSwitches = []
        res.banners.forEach((item, index) => {
          if (isEmptyObject(item)) {
            res.banners.splice(index, 1)
          }
          res.positionSwitches.push({
            position: item.position,
            switchValue: item.switch
          })
        })
        this.$emit('submit', res)
      })
    },
    selectPromotion (val) {
      this.is_select_active = false
      if (!val.url) {
        this.thePromotionIsUrl = true
      }
      let items = this.form.banners
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (item.position === this.location) {
          item.url = val.url
          // item.banner = val.banner
          item.resourceId = val.resourceId
          item.resourceName = val.resourceName
          item.title = val.title
          item.description = val.description
          break
        }
      }
    },
    selctPromotion (position, item) {
      this.currentItem = item
      this.location = position
      this.is_select_active = true
      this.dialog_title = '选择' + this.getTitleForLocation(position)
    },
    getTitleForLocation (position) {
      return position === HOME ? '探索首页弹屏' : (position === MALL ? '商城首页弹屏' : '')
    },
    getPositionDescription (position) {
      return this.getTitleForLocation(position) + '，每日每用户仅弹出一次'
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.active-table-item{
     padding:10px 20px;
    //  :global
    //  tr{
    //      display: -webkit-box
    //  }
}
.notes-text{
    color: red;
    font-size: 13px;
}
.active-description{
    color: red;
    font-size: 14px;
    line-height: 25px;
    padding: 0 20px;
}
</style>
<style lang="less">

.active-url{
    display: flex;
    .url-input{
        display: flex;
        min-width: 400px;
        margin-right:20px;
    }
}
</style>
